import * as React from "react";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import * as Yup from "yup";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import connect from "react-redux/es/connect/connect";
import { disclosureAction } from "../../../../actions/disclosure.action";

const styles = {
  paper: {
    width: "100%",
    height: "80%",
  },
  dialogContent: {},
};

class EmailDisclosure extends React.Component {
  state = {
    isOpen: false,
    email: "",
    isValid: true,
    emailed: false,
  };

  handleEmail = (e) => {
    this.setState({
      email: e.target.value,
      isValid: Yup.string().email().isValidSync(e.target.value),
    });
  };

  onOpen = () => {
    this.setState({ isOpen: true });
  };

  onClose = (e) => {
    this.setState({ isOpen: false });
  };

  onSubmit = () => {
    const { email } = this.state;
    this.props.dispatch(
      disclosureAction.emailDisclosure({ email })
    );
    this.props.onEmailed();
    this.setState({ isOpen: false });
  };

  render() {
    const { classes } = this.props;
    const { email, isValid, isOpen } = this.state;
    return (
      <React.Fragment>
        <Button
          variant="outlined"
          color="primary"
          onClick={this.onOpen}
          style={{ marginRight: 20 }}
        >
          Email Disclosure
        </Button>
        <Dialog
          open={isOpen}
          maxWidth="sm"
          fullWidth
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <DialogTitle>Email Disclosure</DialogTitle>
          <React.Fragment>
            <DialogContent className={classes.dialogContent}>
              <TextField
                autoFocus
                style={{ minWidth: "80%" }}
                type="email"
                label="Email Address"
                value={email}
                onChange={this.handleEmail}
                error={!isValid}
                helperText={!isValid && "Please Enter a Valid Email Address"}
              />
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={this.onClose}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={!isValid || email === ""}
                onClick={() => this.onSubmit()}
              >
                Submit
              </Button>
            </DialogActions>
          </React.Fragment>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(connect()(EmailDisclosure));



// WEBPACK FOOTER //
// ./src/components/OnboardPortfoliosDialog/components/EmailDisclosure/index.jsx